"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioFileSource = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PropTypes = require("./PropTypes");
var _AudioFileSource = require("./AudioFileSource.styled");
var _useVideoJSPlayer = require("../../hooks/useVideoJSPlayer/useVideoJSPlayer");
var AudioFileSource = exports.AudioFileSource = function AudioFileSource(_ref) {
  var source = _ref.source,
    audioPlayer = _ref.audioPlayer,
    serverTime = _ref.serverTime,
    serverTimeDelta = _ref.serverTimeDelta;
  var id = source._id;
  var isObjectSourceValue = (0, _typeof2["default"])(source.value) === 'object';
  var settings = isObjectSourceValue ? source.value : audioPlayer;
  var audioUrl = isObjectSourceValue ? source.value.url : source.value;
  (0, _useVideoJSPlayer.useVideoJSPlayer)(id, audioUrl, settings, serverTime, serverTimeDelta);
  return /*#__PURE__*/_react["default"].createElement(_AudioFileSource.StyledAudioWrapper, null, /*#__PURE__*/_react["default"].createElement("audio", {
    id: "media_player_".concat(source._id),
    "data-testid": "audio_".concat(source._id),
    className: "video-js vjs-default-skin",
    style: {
      backgroundColor: 'transparent'
    }
  }, "Your browser does not support the audio element."));
};
AudioFileSource.defaultProps = {
  showControls: false,
  audioPlayer: {}
};
AudioFileSource.propTypes = {
  source: _PropTypes.Source,
  audioPlayer: _PropTypes.AudioPlayer,
  serverTime: _propTypes["default"].number,
  serverTimeDelta: _propTypes["default"].number
};